module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/3_62a3ee0196750d26849259ecde291633.png";